import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body2 s-label file-label" }
const _hoisted_2 = { key: 0 }

import { Ref, computed, inject, ref } from 'vue';

import FieldFileSigningActions from 'SharedComponents/Fields/FieldFileSigningActions.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import QuasarFileUploader from 'SharedComponents/ui/File/QuasarFileUploader.vue';
import SLink from 'SharedComponents/ui/Link/SLink.vue';
import { ATTACHMENT_ENDPOINTS } from 'SharedDir/backend/endpoints/attachments';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { useIssueFileAccess } from 'SharedDir/common/composables/useIssueFileAccess';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldFile, FieldValue, FileSetFieldParams } from 'SharedDir/declarations/fields';
import { AttachmentType } from 'SharedDir/declarations/files';
import { NIssue } from 'SharedDir/declarations/issue';
import { IsIssueKey, IssueExportingMenuKey } from 'SharedDir/modules/Issues/Issue/issue.constants';
import { useAuthStore } from 'SharedDir/stores/auth.store';

type FileSetModelValue = FieldValue<FieldFile[] | null>;
type FileItem = Pick<AttachmentType, 'id' | 'name'>;
type FileSetInnerValue = FileItem[];
type FileFieldProps = ValuedFieldProps &
  PropValue<FileSetModelValue> & {
    params: FileSetFieldParams;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileSetField' },
  __name: 'FileSetField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {}
  }, defaultValuedProps),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const issue = inject<Ref<NIssue.IssueWithHistory | null>>(IsIssueKey, ref(null));

const { fileAccess } = useIssueFileAccess(issue);

const emptyFile = ref({});

const { innerValue, emitValue } = useValue<FileSetModelValue, FileSetInnerValue>(props, emit, {
  transform: (v) => {
    if (!v.value) return [];
    return v.value.map(({ fileId: id, value: name }) => ({ id, name }) as FileItem);
  },
  mrofsnart: (iv) => {
    if (!iv || (Array.isArray(iv) && iv.length === 0)) return { value: null };
    console.debug(iv);
    return { value: iv.map(({ id: fileId, name: value }) => ({ fileId, value })) };
  },
});

const removeFile = (fileIndex: number) => {
  innerValue.value.splice(fileIndex, 1);
  emitValue();
};

const addFile = (file: FileItem | null) => {
  if (!file) return;
  emptyFile.value = {};
  innerValue.value.push(file);
  emitValue();
};

const store = useAuthStore();

const { downloadFile } = useFileApi();

const exportDocument = inject(IssueExportingMenuKey);

async function openExportDialog() {
  try {
    if (!exportDocument) {
      return;
    }
    const { attachment } = await exportDocument();
    innerValue.value.push({
      id: attachment.id,
      name: attachment.name,
    });
    emitValue();
  } catch (e) {
    console.error('Aborted', e);
  }
}

const supportsExport = computed(() => props.params.supportsExport);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["column q-field q-validation-component s-input", { 's-input--required': _ctx.required }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.params.example)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _cache[2] || (_cache[2] = _createTextVNode(" (")),
            _createElementVNode("span", {
              class: "s-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(downloadFile)(_ctx.params.example)))
            }, "Образец"),
            _cache[3] || (_cache[3] = _createTextVNode(") "))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue), (fileItem, fileIndex) => {
      return (_openBlock(), _createBlock(QuasarFileUploader, {
        key: fileItem.id || fileIndex,
        ref_for: true,
        ref: "input",
        modelValue: _unref(innerValue)[fileIndex],
        "onUpdate:modelValue": ($event: any) => ((_unref(innerValue)[fileIndex]) = $event),
        class: _normalizeClass(["q-mb-xs", { required: _ctx.required, 's-form-input_wrapper': _ctx.useWrapper }]),
        removable: "",
        required: _ctx.required,
        readonly: _ctx.readonly,
        api: _unref(ATTACHMENT_ENDPOINTS),
        token: _unref(store).token,
        "form-fields": _unref(fileAccess).PRIVATE,
        "accept-size": _ctx.params.maxSize,
        "accept-extensions": _ctx.params.extension,
        onRemove: ($event: any) => (removeFile(fileIndex))
      }, _createSlots({ _: 2 }, [
        (fileItem.id)
          ? {
              name: "header-actions",
              fn: _withCtx(() => [
                _createVNode(FieldFileSigningActions, {
                  "file-id": fileItem.id,
                  "file-name": fileItem.name || ''
                }, null, 8, ["file-id", "file-name"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "onUpdate:modelValue", "class", "required", "readonly", "api", "token", "form-fields", "accept-size", "accept-extensions", "onRemove"]))
    }), 128)),
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock(QuasarFileUploader, {
          key: 0,
          ref: "mainUploader",
          modelValue: emptyFile.value,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((emptyFile).value = $event)),
            addFile
          ],
          api: _unref(ATTACHMENT_ENDPOINTS),
          token: _unref(store).token,
          "error-message": _ctx.errorMessage,
          "form-fields": _unref(fileAccess).PRIVATE,
          "accept-extensions": _ctx.params.extension,
          "accept-size": _ctx.params.maxSize
        }, _createSlots({ _: 2 }, [
          (supportsExport.value)
            ? {
                name: "uploader-title",
                fn: _withCtx(({ title }) => [
                  _createTextVNode(_toDisplayString(title) + ", или воспользуйтесь ", 1),
                  _createVNode(SLink, {
                    class: "inverted",
                    label: "экспортом",
                    onClick: openExportDialog
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue", "api", "token", "error-message", "form-fields", "accept-extensions", "accept-size"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})